import { HttpContextToken } from '@angular/common/http';

// Marcado antes da cadeia HTTP: o interceptor de erros retorna antes do de autenticação.
export const TRATAR_401_SESSAO = new HttpContextToken<boolean>(() => false);
